import { ViewColumnOutlined } from '@mui/icons-material';
import {
  Checkbox,
  IconButton,
  IconButtonProps,
  ListItemIcon,
  Tooltip,
  PopoverOrigin,
  MenuList,
  MenuItem,
  ListSubheader,
} from '@mui/material';
import { useButtonMenu, PopoverArrow } from '@procureai/ui-mui';
import { ReactNode } from 'react';

import { Content } from './ColumnVisibilitySelect.styled';

const ANCHOR_ORIGIN: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'right',
};
const TRANSFORM_ORIGIN: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'right',
};

export interface ColumnVisibilitySelectItem {
  name: string;
  title?: string;
  children?: ColumnVisibilitySelectItem[];
  disableToggle?: boolean;
}

export interface ColumnVisibilitySelectProps extends IconButtonProps {
  tooltip?: ReactNode;
  items: ColumnVisibilitySelectItem[];
  getItemChecked: (itemName: string) => boolean;
  onItemToggle: (name: string) => void;
}

export const ColumnVisibilitySelect = ({
  tooltip,
  items,
  children,
  getItemChecked,
  onItemToggle,
  ...otherProps
}: ColumnVisibilitySelectProps) => {
  const { menuProps, buttonProps } = useButtonMenu();

  const handleToggle = (item: ColumnVisibilitySelectItem) => () => {
    onItemToggle(item.name);
  };

  return (
    <>
      <Tooltip title={tooltip as any} arrow>
        <IconButton size="small" color="inherit" {...otherProps} {...buttonProps}>
          <ViewColumnOutlined fontSize="small" color="inherit" />
        </IconButton>
      </Tooltip>
      <PopoverArrow
        open={menuProps.open}
        anchorEl={menuProps.anchorEl}
        onClose={menuProps.onClose}
        anchorOrigin={ANCHOR_ORIGIN}
        transformOrigin={TRANSFORM_ORIGIN}
      >
        <Content>
          <MenuList disablePadding>
            {items.map((item) =>
              item.children ? (
                <div key={item.name}>
                  <ListSubheader sx={{ lineHeight: 2, pt: 1 }}>{item.name}</ListSubheader>
                  {item.children.map((child) => (
                    <MenuItem
                      key={child.name}
                      sx={{ pt: 0, pb: 0, pl: 5 }}
                      onClick={handleToggle(child)}
                      disabled={child.disableToggle}
                    >
                      <ListItemIcon>
                        <Checkbox size="small" edge="start" checked={getItemChecked(child.name)} tabIndex={-1} />
                      </ListItemIcon>
                      <span>{child.title}</span>
                    </MenuItem>
                  ))}
                </div>
              ) : (
                <MenuItem
                  key={item.name}
                  sx={{ pt: 0, pb: 0 }}
                  onClick={handleToggle(item)}
                  disabled={item.disableToggle}
                >
                  <ListItemIcon>
                    <Checkbox size="small" edge="start" checked={getItemChecked(item.name)} tabIndex={-1} />
                  </ListItemIcon>
                  <span>{item.title}</span>
                </MenuItem>
              ),
            )}
          </MenuList>
        </Content>
      </PopoverArrow>
    </>
  );
};
